import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useImperativeHandle, useRef, forwardRef } from 'react';
import { usePreferences } from '../../context/PreferencesContext';
import { usePanelPreferences } from '../../hooks/usePanelPreferences';
import { PreferencesContainer } from '../extra/preferences/PreferencesContainer';
import PredictionOptionsPanel from './PredictionOptionsPanel';
function PredictionPreferences(props, ref) {
    const formRef = useRef(null);
    const preferences = usePreferences();
    const predictionPreferences = usePanelPreferences('prediction');
    const saveHandler = useCallback((values) => {
        preferences.dispatch({
            type: 'SET_PANELS_PREFERENCES',
            payload: { key: 'prediction', value: values },
        });
    }, [preferences]);
    useImperativeHandle(ref, () => ({
        saveSetting: () => {
            formRef.current.submitForm();
        },
    }), []);
    return (_jsx(PreferencesContainer, { style: { backgroundColor: 'white' }, children: _jsx(PredictionOptionsPanel, { onSubmit: saveHandler, options: predictionPreferences, ref: formRef, hideName: true }) }));
}
export default forwardRef(PredictionPreferences);
